import React from 'react';
import { Loader, BaasicTable, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const LinksTemplate = ({
	t,
	viewStore,
	viewStore: { listStore, tableData, queryUtility, isSuperAdminOrganization, isSeller, isWarehouse },
	headerCell,
	actions,
}) => {
	if (viewStore.loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="Links">
				{isSuperAdminOrganization && (
					<button
						className="btn btn--med btn--primary btn--primary--negative"
						disabled={viewStore.loading}
						onClick={viewStore.openAddLinkModal}
					>
						Add new link
					</button>
				)}
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions: viewStore,
				}}
				data={listStore.data.slice()}
			/>
		</section>
	);
};

export default defaultTemplate(LinksTemplate);
